import { deleteReq, get, post, put } from '../../../../infra/rest';
import requestConfig from '../../../../shared/config/request';
import { REMINDER_MESSAGE_STATUS } from '../typings/message-types';
import { GetTriggeredRemindersResponse } from '../typings/reminder';

export const getGeneratedMessage = async ({
  orgId,
  chatMessageId,
}: {
  orgId: string;
  chatMessageId: string;
}): Promise<{
  reminderMessage: string;
  chatId: string;
}> => {
  return await post<{
    reminderMessage: string;
    chatId: string;
  }>(
    `${requestConfig.aiBotBaseUrl}/v1/reminders/generate-message`,
    {
      body: JSON.stringify({ orgId, chatMessageId }),
    },
    true,
    false,
    true
  );
};

export const setReminder = async ({
  orgId,
  chatId,
  reminderMessage,
  userIds,
  createdBy,
}: {
  orgId: string;
  chatId: string;
  reminderMessage: string;
  userIds: string[];
  createdBy: string;
}) => {
  return await post<{
    reminderMessage: string;
    chatId: string;
  }>(
    `${requestConfig.aiBotBaseUrl}/v1/reminders/detect`,
    {
      body: JSON.stringify({ orgId, chatId, reminderMessage, userIds, createdBy }),
    },
    true,
    false,
    true
  );
};

export const deleteReminder = async ({ reminderId }: { reminderId: string }) => {
  return await deleteReq(`${requestConfig.aiBotBaseUrl}/v1/reminders/${reminderId}`, undefined, true, false, true);
};

export const updateReminderStatus = async ({
  reminderId,
  status,
}: {
  reminderId: string;
  status: Omit<REMINDER_MESSAGE_STATUS, 'PENDING'>;
}) => {
  return await put<{
    reminderId: string;
    reminderStatus: REMINDER_MESSAGE_STATUS;
    reminderMessageId: string;
    reminderTriggerMessageId: string;
  }>(
    `${requestConfig.aiBotBaseUrl}/v1/reminders/${reminderId}/status`,
    {
      body: JSON.stringify({
        status,
      }),
    },
    true,
    false,
    true
  );
};

export const editReminder = async ({
  reminderMessage,
  userIds,
  reminderId,
}: {
  reminderId: string;
  reminderMessage: string;
  userIds: string[];
}) => {
  return await put(
    `${requestConfig.aiBotBaseUrl}/v1/reminders/${reminderId}`,
    {
      body: JSON.stringify({
        reminderMessage,
        userIds,
      }),
    },
    true,
    false,
    true
  );
};

export const getTriggeredReminders = async ({ lastCheckedAt = '2026-01-30T00:00:00Z' }: { lastCheckedAt: string }) => {
  return await get<GetTriggeredRemindersResponse>(
    `/v1/conversation/reminders/triggered?lastCheckedAt=${lastCheckedAt}`,
    {},
    true
  );
};
